import { FormattedMessage } from 'react-intl';

import Button from '../../../../components/Button/Button';
import { CalculatorTypeE } from '../../../../declarations/enums/common';
import { RoutesPathE } from '../../../../declarations/enums/routes';
import useReactRouter from '../../../../hooks/useReactRouter';
import { SectionTitleStyled, SingleButtonWrapperStyled } from '../../HomePage.styled';
import { ImageStyled, ImageWrapperStyled } from './TransportationOffset.styled';

type TransportationOffsetPropsT = {
  isWayajCustomer: boolean;
};

const TransportationOffset: React.FC<TransportationOffsetPropsT> = ({ isWayajCustomer }) => {
  const { navigateTo } = useReactRouter();

  return (
    <>
      <div>
        <SectionTitleStyled level={3} align="center">
          <FormattedMessage
            id="home.calculateAndOffsetSection.label"
            defaultMessage="Instantly Calculate & Offset Your Transportation"
          />
        </SectionTitleStyled>

        {!isWayajCustomer && (
          <FormattedMessage
            id="home.calculateAndOffsetSection.text0"
            defaultMessage="Whether flying or driving, taking the ferry or train, our innovative technology provides the opportunity to better understand and counteract the carbon generated from all your travels."
          />
        )}

        <ImageWrapperStyled>
          <ImageStyled src={'/images/transportation-home-img-1.png'} alt="imageAlt" />
        </ImageWrapperStyled>

        <FormattedMessage
          id="home.calculateAndOffsetSection.text"
          defaultMessage="<p>In 2018 alone, commercial flights produced 900 million Tons-Co2, and car trips to and from airports and hotels produced 70 million Tons-Co2. By 2023, over 700 million people will book hotel reservations online equaling 94,500,000 Tons-Co2, or the energy consumed by 10,904,685 homes in a single year.</p> <p>While 100% carbon-free transportation options (especially for long-haul travel) are not currently available, the most simple and accessible way to alleviate the effects on our environment is offsetting.</p> <p>Show the world travel and a healthy planet can coexist. Start using the CFC Engine™ to offset all your transportation today.</p>"
          values={{
            p: (...chunks: string[]) => <p>{chunks}</p>,
          }}
        />
      </div>

      <SingleButtonWrapperStyled>
        <Button
          isInverted
          onClick={() =>
            navigateTo(
              RoutesPathE.TRANSPORTATION_PAGE,
              { calculate: CalculatorTypeE.TRANSPORT },
              true
            )
          }
        >
          <FormattedMessage id="button.calculateNow" defaultMessage="Calculate now" />
        </Button>
      </SingleButtonWrapperStyled>
    </>
  );
};

export default TransportationOffset;
